import { getFormattedDurationShort } from '../../../../../common/duration'
import React, { useEffect, useState } from 'react'
import { CrossClientQueryExecution, CrossClientQueryPhases } from '../../../../../models/CrossClient'
import { setCrossClientResultsExecutionPhase } from '../../../../../store/crossClient/crossClientResults'
import { TrackEvent, useTracking } from '../../../../../apps/professional-app/fa/common/tracking'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useCancelCrossClientQueryMutation } from '../../../../../store/crossClient/crossClientExecution'
import { CrossClientStopModal } from '../../../Modal/CrossClientStopModal'

export interface CrossClientQueryRunningProps {
  execution: CrossClientQueryExecution
}

export const CrossClientQueryRunningInfo: React.FC<CrossClientQueryRunningProps> = ({ execution }) => {
  const dispatch = useAppDispatch()

  const { tracked } = useTracking()

  const accountId = useAppSelector(selectAccountId)

  const [triggerCancelCrossClientQuery, { isLoading: cancelLoading }] = useCancelCrossClientQueryMutation()

  const [now, setNow] = useState<Date>(new Date())
  const [showStopModal, setShowStopModal] = useState<boolean>(false)

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const handleStopExecution = tracked(
    async () => {
      try {
        await triggerCancelCrossClientQuery({ accountId, executionId: execution.id }).unwrap()
        dispatch(setCrossClientResultsExecutionPhase(CrossClientQueryPhases.CANCELED))
        setShowStopModal(false)
      } catch (e) {
        console.error(e)
      }
    },
    {
      eventName: TrackEvent.X_CLIENT_QUERY_STOPPED,
      eventDetails: { executionId: execution.id },
    },
  )

  return (
    <>
      {showStopModal ? (
        <CrossClientStopModal show={showStopModal} loading={cancelLoading} onStop={handleStopExecution} onContinue={() => setShowStopModal(false)} />
      ) : null}
      <div className='d-flex flex-column gap-2'>
        <div className='paragraph-small zocks-text-gray-700'>Running for {getFormattedDurationShort(execution.updatedAt, now.toISOString())}</div>
        <div className='d-flex gap-1 align-items-center zocks-text-danger cursor-pointer' role='button' onClick={() => setShowStopModal(true)}>
          <i className='bi bi-stop-fill fs-5' />
          <div className='paragraph-small medium'>Stop query</div>
        </div>
      </div>
    </>
  )
}
